export const fields = [
  {
    label: 'First Name',
    key: 'firstName',
    isRequired: true,
  },
  {
    label: 'Last Name',
    key: 'lastName',
  },
  {
    label: 'Role',
    key: 'role',
  },
  {
    label: 'Email',
    key: 'email',
    type: 'email',
  },
  {
    label: 'Phone',
    key: 'phone',
    type: 'Phone',
  },
  {
    label: 'Back-up First Name',
    key: 'backUpFirstName',
  },
  {
    label: 'Back-up Last Name',
    key: 'backUpLastName',
  },
  {
    label: 'Back-up Email',
    key: 'backUpEmail',
    type: 'email',
  },
  {
    label: 'Back-up Phone',
    key: 'backUpPhone',
    type: 'Phone',
  },
];
